"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.52,21.08A1.53,1.53,0,0,1,19,19.56V15.05a7,7,0,0,0-4-6.33A3,3,0,0,0,9,8.72a7,7,0,0,0-4,6.33v4.51a1.52,1.52,0,0,1-1.52,1.52.48.48,0,0,0-.48.48.47.47,0,0,0,.48.48H9.57a2.47,2.47,0,0,0,4.86,0h6.09a.48.48,0,0,0,.48-.48A.49.49,0,0,0,20.52,21.08Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.49,9.52A.47.47,0,0,1,3,9a6,6,0,0,1,6-6,.48.48,0,0,1,.48.48A.47.47,0,0,1,9,4,5,5,0,0,0,4,9,.48.48,0,0,1,3.49,9.52Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.48,9.52A.47.47,0,0,1,0,9a9,9,0,0,1,9-9,.47.47,0,0,1,.48.48A.48.48,0,0,1,9,1,8,8,0,0,0,1,9,.47.47,0,0,1,.48,9.52Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.52,9.52A.47.47,0,0,1,20,9a5,5,0,0,0-5-5,.47.47,0,0,1-.48-.48A.48.48,0,0,1,15,3.05a6,6,0,0,1,6,6A.48.48,0,0,1,20.52,9.52Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.52,9.52A.47.47,0,0,1,23,9a8,8,0,0,0-8-8,.48.48,0,0,1-.48-.48A.47.47,0,0,1,15,.05a9,9,0,0,1,9,9A.47.47,0,0,1,23.52,9.52Z",
    fill: "#024965"
  }), ' ');
};

exports["default"] = _default;